import { render, staticRenderFns } from "./IndicatorMetrics.vue?vue&type=template&id=ed665e58"
import script from "./IndicatorMetrics.vue?vue&type=script&lang=js"
export * from "./IndicatorMetrics.vue?vue&type=script&lang=js"
import style0 from "./IndicatorMetrics.vue?vue&type=style&index=0&id=ed665e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports